import { Component, OnInit, Inject, HostListener, OnDestroy  } from '@angular/core';
import { FormControl } from '@angular/forms';
import {GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { BQRequestService } from'../service/bqrequest.service';
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlarmsqueryService } from '../service/alarmsquery.service';

//Aqui se arma la estructura de datos pasada al dialogo con grafico
export interface DialogData {
  name: string;
  chartdata: any;
  value: string;
}

const Doptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const months = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]

@Component({
  selector: 'app-eficiency',
  templateUrl: './eficiency.component.html',
  styleUrls: ['./eficiency.component.css']
})
export class EficiencyComponent implements OnInit, OnDestroy {

  constructor(private requestService: BQRequestService,
    private markersService: MarkersService, private dataService: AlarmsqueryService,
    public dialog: MatDialog) { }

  private subMarkers: any;
  markers: MarkerInterface[];
  public sites: any[] = [];
  public query: any[] = [];
  public ODList = [];
  public justkwhData = [];
  public totalKPIs = [];

  public originalQuery: any[] = [];

  public myNewDims; //Adaptive size
  public loadingData = Promise.resolve(true);

  public maxDate = new Date()
  dummy = new Date();
  public minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back
  
  public tree;
  public TopSelector = new FormControl();
  public TopLvlSelected = '';
  public topLevel;
  public MidSelector = new FormControl();
  public MidLvlSelected = '';
  public midLevel;
  public LastSelector = new FormControl();
  public LastLvlSelected = '';
  public lastLevel;

  public TotalUsers = 0;
  public TotalM2 = 0;
  public date1 = new FormControl();
  public date2 = new FormControl();
  public sub;
  public Months: any[] = [];
  public NewGChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top',textStyle:{fontSize: 10}},
      chartArea: { left: 50, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      hAxis: {
        textStyle:{fontSize: 10},
        // format:'MMMM',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMMM']},
        //   }
        // },
        // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{fontSize: 10},
      },
      annotations: {
        highContrast: true,
        textStyle: {
          color: '#000000',
          fontSize: 12
        }
      },
      //colors: ['#424242', '#DC3912', '#FF9900' , '#DC3912', '#FF9900'],
      isStacked: false,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 300
    }
  };
  public Newm2GChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top', textStyle:{fontSize: 10}},
      chartArea: { left: 30, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      hAxis: {
        textStyle:{fontSize: 10}
        // format:'MMMM',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMMM']},
        //   }
        // },
        // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{fontSize: 10}
      },
      annotations: {
        highContrast: true,
        textStyle: {
          color: '#000000',
          fontSize: 12
        }
      },
      colors: ['#DC3912'],
      isStacked: false,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 300 
    }
  };
  public Newkpi1GChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top',textStyle:{fontSize: 10}},
      chartArea: { left: 30, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      hAxis: {
        textStyle:{fontSize: 10}
        // format:'MMMM',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMMM']},
        //   }
        // },
        // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{fontSize: 10}
      },
      annotations: {
        highContrast: true,
        textStyle: {
          color: '#000000',
          fontSize: 12
        }
      },
      colors: ['#FF9900'],
      isStacked: false,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 300 
    }
  };
  public Newkpi2GChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top', textStyle:{fontSize: 10}},
      chartArea: { left: 30, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      hAxis: {
        textStyle:{fontSize: 10}
        // format:'MMMM',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMMM']},
        //   }
        // },
        // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{fontSize: 10}
      },
      annotations: {
        highContrast: true,
        textStyle: {
          color: '#000000',
          fontSize: 12
        }
      },
      colors: ['#109618'],
      isStacked: false,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 300 
    }
  };
  public Newkpi3GChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top', textStyle:{fontSize: 10}},
      chartArea: { left: 50, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      hAxis: {
        textStyle:{fontSize: 10}
        // format:'MMMM',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMMM']},
        //   }
        // },
        // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{fontSize: 10}
      },
      annotations: {
        highContrast: true,
        textStyle: {
          color: '#000000',
          fontSize: 12
        }
      },
      colors: ['#0099C6'],
      isStacked: false,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 300 
    }
  };
  
  ngOnInit() {
    document.getElementById('ad').className = 'nav-options mat-button';
    //retrieves the markers to place in tree
    this.subMarkers = this.markersService.getMarkers().subscribe(marker =>{
      this.TotalUsers = 0;
      this.TotalM2 = 0;
      this.markers = marker;
      let sitespreproc = [];
      for (let index = 0; index < this.markers.length; index++){
        this.sites.push({'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office, 'index': index, 'm2': this.markers[index].m2, 'users': this.markers[index].usuarios})
        sitespreproc.push({'zone': this.markers[index].zone, 'city': this.markers[index].city, 'site': this.markers[index].office, 'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office})
        this.TotalUsers += this.markers[index].usuarios;
        this.TotalM2 += parseFloat(this.markers[index].m2);
      }
      
      this.createTree();
      this.topLevel = Object.keys(this.tree);
      this.midLevel = [];
      this.lastLevel = [];
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
            
          }
        }
      }

      // this.Loadingsites = Promise.resolve(true); //para actualizar el contenido de lo cargado desde BD

      
    })
    
    // Aqui tomamos los valores de BDD
    this.sub = this.requestService.sendIndexesRequest().subscribe(result =>{
      this.query = [];
      let newChart = [];
      ////////////////////////////////////////////////Se agrego para mostrar meses////////////////////////////////////////////////////////////////////////////////////////////
      let firstM = result[0][10];
      let YearInit = result[0][10].split('-')[0];

      let YearInitCopy = YearInit;
      let firstMCopy = result[0][10].split('-')[1];
      let firstDateCopy = result[0][10];

      firstM = firstM.split('-');
      firstM = parseInt(firstM[1]) - 1;
      let yearone = true;
      //Esto Rellena un año completo con datos desde Query
      for(let x=firstM; x <  firstM+12; x++){
        
        if(x>11){
          if(yearone){
          YearInit = parseInt(YearInit) //+1
          YearInit = String(YearInit);
          yearone = false;
          }
          this.Months.push(months[x-12]+"-"+YearInit.slice(-2));
        
        }
        else{
          this.Months.push(months[x]+"-"+YearInit);
        }
      } 
      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      for (let parts in result)
      {
        var site = result[parts][0] + '/'+ result[parts][1] + '/' + result[parts][2];
        var tonco2 = result[parts][4];
        var kwhm2 = result[parts][5];
        var m3usuario = result[parts][6];
        this.justkwhData.push({"id": site, "Fecha": result[parts][10], "kwh": result[parts][3] })
        this.query.push({"id": site, "tonco2": tonco2, "kwhm2": kwhm2, "m3usuario": m3usuario, "kpi1": 0, "kpi2": 0, "kpi3": 0, "Fecha": result[parts][10]})
        this.originalQuery.push({"id": site, "tonco2": tonco2, "kwhm2": kwhm2, "m3usuario": m3usuario, "kpi1": 0, "kpi2": 0, "kpi3": 0, "Fecha": result[parts][10]})

      }

      //aqui obtengo los datos que no mide GVC
      let sub = this.dataService.getOtherData().subscribe(result =>{
        this.ODList = [];
        for(let i in result){
          this.ODList.push({date: new Date(result[i]['Fecha']), place: result[i]['Place'], gas: result[i]['Gas'], diesel: result[i]['Diesel'], sales: result[i]['Ventas'], id: result[i]['id']})
        }
        this.ODList.sort(this.dynamicSort('date'));

        for(let s in this.justkwhData){
          let m2 = this.getm2FromList(this.justkwhData[s].id);
          let users = this.getUsersFromList(this.justkwhData[s].id);
          if(this.ODList[s] != undefined)//aqui va other data con valores
          {
            this.totalKPIs.push({'Fecha': this.justkwhData[s]['Fecha'], 'kpi1': (this.justkwhData[s]['kwh'] + (this.ODList[s]['diesel']*39.75)*1 + (this.ODList[s]['gas']*12.6389)*0.1 ) / this.ODList[s]['sales'], 'kpi2': (this.justkwhData[s]['kwh'] + (this.ODList[s]['diesel']*39.75)*1 + (this.ODList[s]['gas']*12.6389)*0.1 ) / m2, 'kpi3': (this.justkwhData[s]['kwh'] + (this.ODList[s]['diesel']*39.75)*1 + (this.ODList[s]['gas']*12.6389)*0.1 ) / users })
          }
          else//aqui va other data en 0
          {
            this.totalKPIs.push({'Fecha': this.justkwhData[s]['Fecha'], 'kpi1': 0, 'kpi2': 0, 'kpi3': 0 })
          }          
        }

        for(let j in this.query){
          if(this.totalKPIs[j] != undefined )
          {
            this.query[j]['kpi1'] = this.totalKPIs[j]['kpi1'];this.originalQuery[j]['kpi1'] = this.totalKPIs[j]['kpi1'];
            this.query[j]['kpi2'] = this.totalKPIs[j]['kpi2'];this.originalQuery[j]['kpi2'] = this.totalKPIs[j]['kpi2'];
            this.query[j]['kpi3'] = this.totalKPIs[j]['kpi3'];this.originalQuery[j]['kpi3'] = this.totalKPIs[j]['kpi3'];
          }
        }

        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, kpi1: 0, kpi2: 0, kpi3: 0, total: 0};
              newChart.push(this[a.id]);
          }
          this[a.id].tonco2 += a.tonco2;
          this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
          this[a.id].kwhm2 += a.kwhm2;
          this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
          this[a.id].m3usuario += a.m3usuario;
          this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
          this[a.id].kpi1 += a.kpi1;
          this[a.id].kpi1 = (Math.round((this[a.id].kpi1 + Number.EPSILON) * 100) / 100);
          this[a.id].kpi2 += a.kpi2;
          this[a.id].kpi2 = (Math.round((this[a.id].kpi2 + Number.EPSILON) * 100) / 100);
          this[a.id].kpi3 += a.kpi3;
          this[a.id].kpi3 = (Math.round((this[a.id].kpi3 + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario + a.kpi1 + a.kpi2 + a.kpi3;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        //tonco2
        let tableCO2 = new google.visualization.DataTable();
        tableCO2.addColumn("string", "Sitio");
        tableCO2.addColumn("number", "Total Emisiones CO2");
        //m2
        let tablem2 = new google.visualization.DataTable();
        tablem2.addColumn("string", "Sitio");
        tablem2.addColumn("number", "Total kW⋅h/m²");
        //KPI1
        let tablekpi1 = new google.visualization.DataTable();
        tablekpi1.addColumn("string", "Sitio");
        tablekpi1.addColumn("number", "Total Consumo(USD)/Ventas"); //Consumo/Área y Consumo/Usuarios
        //KPI2
        let tablekpi2 = new google.visualization.DataTable();
        tablekpi2.addColumn("string", "Sitio");
        tablekpi2.addColumn("number", "Total Consumo(USD)/Área");
        //KPI3
        let tablekpi3 = new google.visualization.DataTable();
        tablekpi3.addColumn("string", "Sitio");
        tablekpi3.addColumn("number", "Total Consumo(USD)/Usuarios");
        newChart.forEach(function (a){
          if(a.id == 'Sierra/Quito/Inaquito')
          {
            tableCO2.addRow(['Sierra/Quito/Iñaquito', a.tonco2])
            tablem2.addRow(['Sierra/Quito/Iñaquito', a.kwhm2])
            tablekpi1.addRow(['Sierra/Quito/Iñaquito', a.kpi1])
            tablekpi2.addRow(['Sierra/Quito/Iñaquito', a.kpi2])
            tablekpi3.addRow(['Sierra/Quito/Iñaquito', a.kpi3])
          }
          else
          {
            tableCO2.addRow([a.id, a.tonco2])
            tablem2.addRow([a.id, a.kwhm2])
            tablekpi1.addRow([a.id, a.kpi1])
            tablekpi2.addRow([a.id, a.kpi2])
            tablekpi3.addRow([a.id, a.kpi3])
          }
          
        })
        this.date2.setValue(new Date());
        this.date1.setValue(new Date(firstDateCopy));

        //updateCo2
        this.NewGChart.dataTable = tableCO2;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
        //updatem2
        this.Newm2GChart.dataTable = tablem2;
        Ccomponent = this.Newm2GChart.component;
        wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
        //updatekpi1
        this.Newkpi1GChart.dataTable = tablekpi1;
        Ccomponent = this.Newkpi1GChart.component;
        wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
        //updatekpi2
        this.Newkpi2GChart.dataTable = tablekpi2;
        Ccomponent = this.Newkpi2GChart.component;
        wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
        //updatekpi3
        this.Newkpi3GChart.dataTable = tablekpi3;
        Ccomponent = this.Newkpi3GChart.component;
        wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
        
        this.loadingData = Promise.resolve(false);
      })

    });

    this.delay(80).then(any =>{
      document.getElementById('ac').className = 'nav-options mat-button selected';
    })

  }

  //get m2
  getm2FromList(id){
    id = id.replaceAll('/', '-');
    let m2;
    for(let i in this.sites){
      if(this.sites[i].bd_id == id){
        m2 = parseInt(this.sites[i].m2)
      }
    }
    return m2

  }

  //get users
  getUsersFromList(id){
    id = id.replaceAll('/', '-');
    let usr;
    for(let i in this.sites){
      if(this.sites[i].bd_id == id){
        usr = parseInt(this.sites[i].users)
      }
    }
    return usr
  }

  //crea el arbol de sitios
  createTree(){
    //Para obtener divisiones del proyecto *arbol
    this.tree = {};
    for (let parts of this.sites)
    {
      var toplvl = parts.bd_id.split('-')[0];
      var medlvl = parts.bd_id.split('-')[1];
      var lowlvl = parts.bd_id.split('-')[2];
      this.addProps(this.tree, toplvl + "."+medlvl+"."+lowlvl, parts.bd_id);

    }
    
    var keys = Object.keys(this.tree);
  }

  //sort menor mayor
  dynamicSort(property) {
    return function(a, b) {
        return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
  }

  //resize 
  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    this.myNewDims = window.innerHeight - 175;

    if(this.myNewDims >= 500){this.NewGChart.options.height = this.myNewDims;}else{this.NewGChart.options.height = 500;}
    if(window.innerWidth <= 600 ){this.NewGChart.options.width = 500;}else{this.NewGChart.options.width = '100%';}

    //updateCo2
    let Ccomponent = this.NewGChart.component;
    let wrapper = Ccomponent.wrapper;
    Ccomponent.draw();
    //updatem2
    Ccomponent = this.Newm2GChart.component;
    wrapper = Ccomponent.wrapper;
    Ccomponent.draw();
    //updatekpi1
    Ccomponent = this.Newkpi1GChart.component;
    wrapper = Ccomponent.wrapper;
    Ccomponent.draw();
    //updatekpi2
    Ccomponent = this.Newkpi2GChart.component;
    wrapper = Ccomponent.wrapper;
    Ccomponent.draw();
    //updatekpi3
    Ccomponent = this.Newkpi3GChart.component;
    wrapper = Ccomponent.wrapper;
    Ccomponent.draw();

    // this.currentChart.options.vAxis.baseline = '55'
    // let ccComponent2 = this.currentChart.component;
    // let ccwrapper2 = ccComponent.wrapper;

    // //redraw
    // ccComponent2.draw();
  }

  //funcion para crear el arbol desde BD
  addProps(obj, arr, val) {

    if (typeof arr == 'string')
        arr = arr.split(".");

    obj[arr[0]] = obj[arr[0]] || {};

    var tmpObj = obj[arr[0]];

    if (arr.length > 1) {
        arr.shift();
        this.addProps(tmpObj, arr, val);
    }
    else
        obj[arr[0]] = val;

    return obj;

  }

  //para filtrar selectores
  filterSelectors(){
    this.delay(10).then(any =>{
      this.midLevel = [];
      this.lastLevel = [];
      if(this.TopSelector.value == ''){ //si no hay nada seleccionado usar todo
        this.topLevel = Object.keys(this.tree);
      }
      else  //sino filtra
      {
        this.topLevel = this.TopSelector.value;
      }
      
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
          }
        }
      }
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      this.query.forEach(function (a) {
        if (!this[a.id]) {
            this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, kpi1: 0, kpi2: 0, kpi3: 0, total: 0};
            newChart.push(this[a.id]);
        }
        this[a.id].tonco2 += a.tonco2;
        this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
        this[a.id].kwhm2 += a.kwhm2;
        this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
        this[a.id].m3usuario += a.m3usuario;
        this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
        this[a.id].kpi1 += a.kpi1;
        this[a.id].kpi1 = (Math.round((this[a.id].kpi1 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi2 += a.kpi2;
        this[a.id].kpi2 = (Math.round((this[a.id].kpi2 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi3 += a.kpi3;
        this[a.id].kpi3 = (Math.round((this[a.id].kpi3 + Number.EPSILON) * 100) / 100);
        this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario + a.kpi1 + a.kpi2 + a.kpi3;
        this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
      }, Object.create(null));

      //tonco2
      let tableCO2 = new google.visualization.DataTable();
      tableCO2.addColumn("string", "Sitio");
      tableCO2.addColumn("number", "Total Emisiones CO2");
      //m2
      let tablem2 = new google.visualization.DataTable();
      tablem2.addColumn("string", "Sitio");
      tablem2.addColumn("number", "Total kW⋅h/m²");
      //KPI1
      let tablekpi1 = new google.visualization.DataTable();
      tablekpi1.addColumn("string", "Sitio");
      tablekpi1.addColumn("number", "Total Consumo(USD)/Ventas"); //Consumo/Área y Consumo/Usuarios
      //KPI2
      let tablekpi2 = new google.visualization.DataTable();
      tablekpi2.addColumn("string", "Sitio");
      tablekpi2.addColumn("number", "Total Consumo(USD)/Área");
      //KPI3
      let tablekpi3 = new google.visualization.DataTable();
      tablekpi3.addColumn("string", "Sitio");
      tablekpi3.addColumn("number", "Total Consumo(USD)/Usuarios");
      newChart.forEach(function (a, index){
        for(let i in this)
        {
          if(this[i].id == a.id)
          {
            tableCO2.addRow([a.id, a.tonco2])
            tablem2.addRow([a.id, a.kwhm2])
            tablekpi1.addRow([a.id, a.kpi1])
            tablekpi2.addRow([a.id, a.kpi2])
            tablekpi3.addRow([a.id, a.kpi3])
          }
        }
      }, this.lastLevel)
      this.TotalUsers = 0;
      this.TotalM2 = 0;
      for(let i in this.lastLevel)
      {
        this.TotalUsers += this.getUsersFromList(this.lastLevel[i].id);
        this.TotalM2 += this.getm2FromList(this.lastLevel[i].id);
      }

      //updateCo2
      this.NewGChart.dataTable = tableCO2;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatem2
      this.Newm2GChart.dataTable = tablem2;
      Ccomponent = this.Newm2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi1
      this.Newkpi1GChart.dataTable = tablekpi1;
      Ccomponent = this.Newkpi1GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi2
      this.Newkpi2GChart.dataTable = tablekpi2;
      Ccomponent = this.Newkpi2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi3
      this.Newkpi3GChart.dataTable = tablekpi3;
      Ccomponent = this.Newkpi3GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
    })
  }

  //para filtrar selector medio
  filterMidSelectors(){
    this.delay(10).then(any =>{
      this.lastLevel = [];
      if(this.MidSelector.value == ''){
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
            }
          }
        }
      }
      else
      {
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              if(this.MidSelector.value.includes(dummy[inds]))
                {
                  this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
                }
            }
          }
        }
      }
      this.LastSelector.setValue(this.lastLevel);
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      this.query.forEach(function (a) {
        if (!this[a.id]) {
            this[a.id] = {  id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, kpi1: 0, kpi2: 0, kpi3: 0, total: 0};
            newChart.push(this[a.id]);
        }this[a.id].tonco2 += a.tonco2;
        this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
        this[a.id].kwhm2 += a.kwhm2;
        this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
        this[a.id].m3usuario += a.m3usuario;
        this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
        this[a.id].kpi1 += a.kpi1;
        this[a.id].kpi1 = (Math.round((this[a.id].kpi1 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi2 += a.kpi2;
        this[a.id].kpi2 = (Math.round((this[a.id].kpi2 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi3 += a.kpi3;
        this[a.id].kpi3 = (Math.round((this[a.id].kpi3 + Number.EPSILON) * 100) / 100);
        this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario + a.kpi1 + a.kpi2 + a.kpi3;
        this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
      }, Object.create(null));

      //tonco2
      let tableCO2 = new google.visualization.DataTable();
      tableCO2.addColumn("string", "Sitio");
      tableCO2.addColumn("number", "Total Emisiones CO2");
      //m2
      let tablem2 = new google.visualization.DataTable();
      tablem2.addColumn("string", "Sitio");
      tablem2.addColumn("number", "Total kW⋅h/m²");
      //KPI1
      let tablekpi1 = new google.visualization.DataTable();
      tablekpi1.addColumn("string", "Sitio");
      tablekpi1.addColumn("number", "Total Consumo(USD)/Ventas"); //Consumo/Área y Consumo/Usuarios
      //KPI2
      let tablekpi2 = new google.visualization.DataTable();
      tablekpi2.addColumn("string", "Sitio");
      tablekpi2.addColumn("number", "Total Consumo(USD)/Área");
      //KPI3
      let tablekpi3 = new google.visualization.DataTable();
      tablekpi3.addColumn("string", "Sitio");
      tablekpi3.addColumn("number", "Total Consumo(USD)/Usuarios");
      newChart.forEach(function (a, index){
        for(let i in this)
        {
          if(this[i].id == a.id)
          {
            tableCO2.addRow([a.id, a.tonco2])
            tablem2.addRow([a.id, a.kwhm2])
            tablekpi1.addRow([a.id, a.kpi1])
            tablekpi2.addRow([a.id, a.kpi2])
            tablekpi3.addRow([a.id, a.kpi3])
          }
        }
      }, this.lastLevel)

      this.TotalUsers = 0;
      this.TotalM2 = 0;
      for(let i in this.lastLevel)
      {
        this.TotalUsers += this.getUsersFromList(this.lastLevel[i].id);
        this.TotalM2 += this.getm2FromList(this.lastLevel[i].id);
      }

      //updateCo2
      this.NewGChart.dataTable = tableCO2;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatem2
      this.Newm2GChart.dataTable = tablem2;
      Ccomponent = this.Newm2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi1
      this.Newkpi1GChart.dataTable = tablekpi1;
      Ccomponent = this.Newkpi1GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi2
      this.Newkpi2GChart.dataTable = tablekpi2;
      Ccomponent = this.Newkpi2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi3
      this.Newkpi3GChart.dataTable = tablekpi3;
      Ccomponent = this.Newkpi3GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();      
      
    })
  }

  //para filtrar ultimo nivel
  filterLastSelector(){ 
    this.delay(10).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      this.query.forEach(function (a) {
        if (!this[a.id]) {
            this[a.id] = {  id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, kpi1: 0, kpi2: 0, kpi3: 0, total: 0};
            newChart.push(this[a.id]);
        }
        this[a.id].tonco2 += a.tonco2;
        this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
        this[a.id].kwhm2 += a.kwhm2;
        this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
        this[a.id].m3usuario += a.m3usuario;
        this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
        this[a.id].kpi1 += a.kpi1;
        this[a.id].kpi1 = (Math.round((this[a.id].kpi1 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi2 += a.kpi2;
        this[a.id].kpi2 = (Math.round((this[a.id].kpi2 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi3 += a.kpi3;
        this[a.id].kpi3 = (Math.round((this[a.id].kpi3 + Number.EPSILON) * 100) / 100);
        this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario + a.kpi1 + a.kpi2 + a.kpi3;
        this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
      }, Object.create(null));

      
        //tonco2
        let tableCO2 = new google.visualization.DataTable();
        tableCO2.addColumn("string", "Sitio");
        tableCO2.addColumn("number", "Total Emisiones CO2");
        //m2
        let tablem2 = new google.visualization.DataTable();
        tablem2.addColumn("string", "Sitio");
        tablem2.addColumn("number", "Total kW⋅h/m²");
        //KPI1
        let tablekpi1 = new google.visualization.DataTable();
        tablekpi1.addColumn("string", "Sitio");
        tablekpi1.addColumn("number", "Total Consumo(USD)/Ventas"); //Consumo/Área y Consumo/Usuarios
        //KPI2
        let tablekpi2 = new google.visualization.DataTable();
        tablekpi2.addColumn("string", "Sitio");
        tablekpi2.addColumn("number", "Total Consumo(USD)/Área");
        //KPI3
        let tablekpi3 = new google.visualization.DataTable();
        tablekpi3.addColumn("string", "Sitio");
        tablekpi3.addColumn("number", "Total Consumo(USD)/Usuarios");

      if(this.LastSelector.value == '')
      {
        newChart.forEach(function (a, index){
          for(let i in this)
          {
            if(this[i].id == a.id)
            {
              tableCO2.addRow([a.id, a.tonco2])
              tablem2.addRow([a.id, a.kwhm2])
              tablekpi1.addRow([a.id, a.kpi1])
              tablekpi2.addRow([a.id, a.kpi2])
              tablekpi3.addRow([a.id, a.kpi3])
            }
          }
        }, this.lastLevel)

        this.TotalUsers = 0;
        this.TotalM2 = 0;
        for(let i in this.lastLevel)
        {
          this.TotalUsers += this.getUsersFromList(this.lastLevel[i].id);
          this.TotalM2 += this.getm2FromList(this.lastLevel[i].id);
        }
      }
      else
      {
        newChart.forEach(function (a, index){
          for(let i in this)
          {
            if(this[i].id == a.id)
            {
              tableCO2.addRow([a.id, a.tonco2])
              tablem2.addRow([a.id, a.kwhm2])
              tablekpi1.addRow([a.id, a.kpi1])
              tablekpi2.addRow([a.id, a.kpi2])
              tablekpi3.addRow([a.id, a.kpi3])
            }
          }
        }, this.LastSelector.value)

        this.TotalUsers = 0;
        this.TotalM2 = 0;
        for(let i in this.LastSelector.value)
        {
          this.TotalUsers += this.getUsersFromList(this.LastSelector.value[i].id);
          this.TotalM2 += this.getm2FromList(this.LastSelector.value[i].id);
      }
      }
      //updateCo2
      this.NewGChart.dataTable = tableCO2;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatem2
      this.Newm2GChart.dataTable = tablem2;
      Ccomponent = this.Newm2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi1
      this.Newkpi1GChart.dataTable = tablekpi1;
      Ccomponent = this.Newkpi1GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi2
      this.Newkpi2GChart.dataTable = tablekpi2;
      Ccomponent = this.Newkpi2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi3
      this.Newkpi3GChart.dataTable = tablekpi3;
      Ccomponent = this.Newkpi3GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();     
    })
  }

  //evento de grafica
  onSelect(event) {
    //Aqui se procesa para co2
    if((event.columnLabel == "Total Emisiones CO2" || event.column == 1) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total Emisiones CO2', this.originalQuery);
      return;
    }
    else if((event.columnLabel == "Total Emisiones CO2" || event.column == 1) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'tonco2', this.NewGChart.dataTable.wg[0]);
      return;
    }
    
    //Aqui se procesa para kwh
    if((event.columnLabel == "Total kW⋅h/m²" || event.column == 2) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total kW⋅h/m²', this.originalQuery);
      return;
    }
    else if((event.columnLabel == "Total kW⋅h/m²" || event.column == 2) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'kwh', this.NewGChart.dataTable.wg[0]);
      return;
    }

    //Aqui se procesa para Agua
    if((event.columnLabel == "Total m³/Usuario" || event.column == 3) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total m³/Usuario', this.originalQuery);
    }
    else if((event.columnLabel == "Total m³/Usuario" || event.column == 3) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'water', this.NewGChart.dataTable.wg[0]);
    }
  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker1(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let fulldate = [year, month, 1].join('-');
    this.date1.setValue(new Date(fulldate));
    this.date1.updateValueAndValidity();
    dp.close();
    this.chageDateFilter(null);
  }

  closeDatePicker2(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    this.date2.setValue( lastDayOfMonth );
    this.date2.updateValueAndValidity();
    dp.close();
    this.chageDateFilter(null);
  }

  //evento al cambiar fecha
  chageDateFilter(event){
    let startDate = this.date1.value;
    let endDate = this.date2.value;

    this.query = this.originalQuery.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= startDate && aDate <= endDate;
    });
        
    this.delay(10).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      
      this.query.forEach(function (a) {
        if (!this[a.id]) {
            this[a.id] = {  id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, kpi1: 0, kpi2: 0, kpi3: 0, total: 0};
            newChart.push(this[a.id]);
        }
        
        this[a.id].tonco2 += a.tonco2;
        this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
        this[a.id].kwhm2 += a.kwhm2;
        this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
        this[a.id].m3usuario += a.m3usuario;
        this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
        this[a.id].kpi1 += a.kpi1;
        this[a.id].kpi1 = (Math.round((this[a.id].kpi1 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi2 += a.kpi2;
        this[a.id].kpi2 = (Math.round((this[a.id].kpi2 + Number.EPSILON) * 100) / 100);
        this[a.id].kpi3 += a.kpi3;
        this[a.id].kpi3 = (Math.round((this[a.id].kpi3 + Number.EPSILON) * 100) / 100);
        this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario + a.kpi1 + a.kpi2 + a.kpi3;
        this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
      }, Object.create(null));

      //tonco2
      let tableCO2 = new google.visualization.DataTable();
      tableCO2.addColumn("string", "Sitio");
      tableCO2.addColumn("number", "Total Emisiones CO2");
      //m2
      let tablem2 = new google.visualization.DataTable();
      tablem2.addColumn("string", "Sitio");
      tablem2.addColumn("number", "Total kW⋅h/m²");
      //KPI1
      let tablekpi1 = new google.visualization.DataTable();
      tablekpi1.addColumn("string", "Sitio");
      tablekpi1.addColumn("number", "Total Consumo(USD)/Ventas"); //Consumo/Área y Consumo/Usuarios
      //KPI2
      let tablekpi2 = new google.visualization.DataTable();
      tablekpi2.addColumn("string", "Sitio");
      tablekpi2.addColumn("number", "Total Consumo(USD)/Área");
      //KPI3
      let tablekpi3 = new google.visualization.DataTable();
      tablekpi3.addColumn("string", "Sitio");
      tablekpi3.addColumn("number", "Total Consumo(USD)/Usuarios");

      if(this.LastSelector.value == null || this.LastSelector.value == '')
      {
        newChart.forEach(function (a, index){
          for(let i in this)
          {
            if(this[i].id == a.id)
            {
              tableCO2.addRow([a.id, a.tonco2])
              tablem2.addRow([a.id, a.kwhm2])
              tablekpi1.addRow([a.id, a.kpi1])
              tablekpi2.addRow([a.id, a.kpi2])
              tablekpi3.addRow([a.id, a.kpi3])
            }
          }
        }, this.lastLevel)
      }
      else
      {
        newChart.forEach(function (a, index){
          for(let i in this)
          {
            if(this[i].id == a.id)
            {
              tableCO2.addRow([a.id, a.tonco2])
              tablem2.addRow([a.id, a.kwhm2])
              tablekpi1.addRow([a.id, a.kpi1])
              tablekpi2.addRow([a.id, a.kpi2])
              tablekpi3.addRow([a.id, a.kpi3])
            }
          }
        }, this.LastSelector.value)
      }

      //updateCo2
      this.NewGChart.dataTable = tableCO2;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatem2
      this.Newm2GChart.dataTable = tablem2;
      Ccomponent = this.Newm2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi1
      this.Newkpi1GChart.dataTable = tablekpi1;
      Ccomponent = this.Newkpi1GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi2
      this.Newkpi2GChart.dataTable = tablekpi2;
      Ccomponent = this.Newkpi2GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
      //updatekpi3
      this.Newkpi3GChart.dataTable = tablekpi3;
      Ccomponent = this.Newkpi3GChart.component;
      wrapper = Ccomponent.wrapper;
      Ccomponent.draw();      
    })
  }

  //evento al ocultar serie
  toggleSeries(event, serie, context){
    let startDate = this.date1.value;
    let endDate = this.date2.value;

    console.log(context, serie);
    this.query = this.originalQuery.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= startDate && aDate <= endDate;
    });
    
    this.delay(10).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      let color1 = '#424242'
      let color2 = '#DC3912'
      let color3 = '#FF9900'
      //si se quiere ocultar emisiones
      if(serie == 'tonco2' && context.c[1].v != null)
        {
          this.query.forEach(function (a) {
            if (!this[a.id]) {
                this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
                newChart.push(this[a.id]);
            }
            // this[a.id].tonco2 += a.tonco2;
            // this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
            this[a.id].tonco2 = null;
            color1 = '#FFFFFF';
            if(context.c[2].v == null){this[a.id].kwhm2 = null; color2 = '#FFFFFF';}
            else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.kwhm2;}
            if(context.c[3].v == null){this[a.id].m3usuario = null; color3 = '#FFFFFF';}
            else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario;}
            //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
            this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
          }, Object.create(null));
    
          let table = new google.visualization.DataTable();
          table.addColumn("string", "Sitio");
          table.addColumn("number", "Total Emisiones CO2");
          table.addColumn("number", "Total kW⋅h/m²");
          table.addColumn("number", "Total m³/Usuario");
          table.addColumn({type:'number', role:'certainty'});
    
          if(this.LastSelector.value == null || this.LastSelector.value == '')
          {
            newChart.forEach(function (a, index){
              for(let i in this)
              {
                if(this[i].id == a.id)
                {
                  table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
                }
              }
            }, this.lastLevel)
          }
          else
          {
            newChart.forEach(function (a, index){
              for(let i in this)
              {
                if(this[i].id == a.id)
                {
                  table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
                }
              }
            }, this.LastSelector.value)
          }
        
          table.sort({column: 4, desc: true});
          this.NewGChart.options.colors = [color1, color2, color3];
    
          this.NewGChart.dataTable = table;
          let Ccomponent = this.NewGChart.component;
          let wrapper = Ccomponent.wrapper;
          Ccomponent.draw();
      }
      else if(serie == 'tonco2' && context.c[1].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          this[a.id].tonco2 += a.tonco2;
          this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.tonco2
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.kwhm2}
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }
      
        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      //si se quiere ocultar kwh
      if(serie == 'kwh' && context.c[2].v != null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.tonco2}
          // this[a.id].kwhm2 += a.kwhm2;
          // this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
          this[a.id].kwhm2 = null;
          color2 = '#FFFFFF';
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }
      
        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      else if(serie == 'kwh' && context.c[2].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          this[a.id].kwhm2 += a.kwhm2;
          this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.kwhm2
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }
      
        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      //si se quiere ocultar agua
      if(serie == 'water' && context.c[3].v != null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.kwhm2}
          // this[a.id].m3usuario += a.m3usuario;
          // this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
          this[a.id].m3usuario = null;
          color3 = '#FFFFFF';
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }
      
        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      else if(serie == 'water' && context.c[3].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.kwhm2}
          this[a.id].m3usuario += a.m3usuario;
          this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }
      
        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }      
    })
  }

  //Para abrir la ventana emergente
  openWindow(name, telem, query){
    const dialogRef = this.dialog.open(OverviewCharts, {
      data: {name: name, value: telem, chartdata: query, months: this.Months}
    });
  }
  
  //delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay ", ms));
  }

  //para dar formato a la fecha
  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  //al salir limpia
  ngOnDestroy(){    
    document.getElementById('ac').className = 'nav-options mat-button';
    this.subMarkers.unsubscribe();
    this.sub.unsubscribe();
    this.sizeChange = function() : void {};
    console.log('desuscrito de todo /Eficiency')

  }

}

//componente para los graficos emergentes.
@Component({
  selector: 'overview-charts',
  templateUrl: 'overview-charts.html',
  styleUrls: ['overview-charts.css']
})
export class OverviewCharts implements OnInit{
  datatable: any;
  showloading: boolean = false;

  public FullChart: GoogleChartInterface = {
    chartType: 'LineChart',
    dataTable: [['ts', 'Total Emisiones Co2', 'Total kWh/m2'],
    ['Quito/R012',          32.5, 4.5],
    ['Quito/R013',          32.0, 4.3],
    ['Quito/R011',          30.5, 4.2],
    ['SantoDomingo/R019',   27.8, 3.8],
    ['SantoDomingo/R021',   26.5, 3.7],
    ['SantoDomingo/R015',   24.2, 3.5],
    ['Guayaquil/R009',      20.1, 3.1],
    ['Guayaquil/R007',      17.5, 2.5],
    ['Guayaquil/R005',      15.9, 2.2],
    ['Guayaquil/R003',      13.5, 1.5]],

    options:{
      legend: {position: 'top'},
      chartArea: { left: 70, right: 70, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      pointShape: "circle",
      pointSize: 6, 
      hAxis: {
        // format:'MMM - YYYY',
        // gridlines: {
        //   units: {
        //     months: {format: ['MMM - YYYY']},
        //   }
        // },
        //ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')] 
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0}
      },
      vAxes: {
        0: {title: "Total Emisiones Co2", titleTextStyle: {color: '#0000FF'}},
        1: {title: "Total kWh/m2", titleTextStyle: {color: '#FF0000'} }
      },
      series: {
         0: {targetAxisIndex: 0},
         1: {targetAxisIndex: 1}
      },

      
      
      isStacked: true,
      // seriesType: 'bars',
      // series: {4: {type: 'line'}},
      height: 578 
    }
  }

  constructor(
    public dialogRef: MatDialogRef<OverviewCharts>,
    private requestService: BQRequestService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {

    this.dialogRef.close('done');
  }

  ngOnInit() {  
    //al iniciar se filtra solo por el site buscado
    this.filtrar(this.data.name);
  };

  filtrar(crit1){
    if(this.data.value != 'Total m³/Usuario')
    {
      let dummy = this.data.chartdata.filter(function(criteria){
        return criteria.id == crit1
        })
      let table = new google.visualization.DataTable();
      table.addColumn("string", "Fecha");
      table.addColumn("number", "Total Emisiones CO2");
      table.addColumn("number", "Total kW⋅h/m²");
      dummy.forEach(function (a, index){
        table.addRow([this.data.months[index], a.tonco2, a.kwhm2])
      },this)
      //actualizo la grafica con valores filtrados
      this.FullChart.dataTable = table;
    }
    else
    {
      let dummy = this.data.chartdata.filter(function(criteria){
        return criteria.id == crit1
        })
      let table = new google.visualization.DataTable();
      table.addColumn("string", "Fecha");
      table.addColumn("number", "Total m³/Usuario");
      dummy.forEach(function (a, index){
        table.addRow([this.data.months[index], a.m3usuario])
      },this)
      //actualizo la grafica con valores filtrados
      this.FullChart.options.vAxes = {0: {title: "Total m³/Usuario", titleTextStyle: {color: '#FF9900'}}};
      this.FullChart.options.colors = ['#FF9900'];
      this.FullChart.dataTable = table;
    }
  }

  //Para imprimir
  justprint(){
    window.print();
 
   }

}

